module.exports = __webpack_public_path__ + "img/shadowbox-flag2.4a7a6dea.png";